import React from 'react';

interface SummaryItem {
  label: string;
  value: React.ReactNode;
  /** Optional colour override for the value text */
  valueColor?: string;
}

interface SummaryBoxProps {
  /** Section title */
  title?: string;
  /** Key-value items to display */
  items: SummaryItem[];
  /** Number of grid columns (default 2) */
  columns?: 1 | 2 | 3 | 4;
  /** Extra style overrides on the container */
  style?: React.CSSProperties;
}

export const SummaryBox: React.FC<SummaryBoxProps> = ({
  title,
  items,
  columns = 2,
  style,
}) => (
  <div
    className="summary-box"
    style={{
      background: '#fff',
      border: '1.5px solid #E2E8F0',
      borderRadius: 16,
      padding: '20px 24px',
      boxShadow: '0 2px 12px rgba(27,58,107,0.06)',
      ...style,
    }}
  >
    {title && (
      <h3 style={{ margin: '0 0 16px', fontSize: 14, fontWeight: 700, color: '#1B3A6B', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {title}
      </h3>
    )}
    <div
      className="summary-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: '0',
        borderTop: '1px solid #F1F5F9',
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          className="summary-item"
          style={{
            padding: '12px 0',
            borderBottom: '1px solid #F1F5F9',
            paddingRight: i % columns !== columns - 1 ? 16 : 0,
            overflow: 'hidden',
          }}
        >
          <div className="summary-item__label" style={{ fontSize: 11, color: '#64748B', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 }}>{item.label}</div>
          <div
            className="summary-item__value"
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: item.valueColor || '#1E293B',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {item.value || '-'}
          </div>
        </div>
      ))}
    </div>
  </div>
);
